/** @format */

import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import intl from 'react-intl-universal';
import locales from '../locales/it.json';
import AppLayout from './AppLayout/AppLayout';
import Requests from './Requests/Requests';
import NewEditRequest from './Requests/NewEditRequest/NewEditRequests';
import Clients from './Clients/Clients';
import Client from './Clients/Client/Client';
import Board from './Board/Board';
import Sales from './Sales/Sales';
import Sale from './Sales/Sale/Sale';
import Login from './Login/Login';
import LocationModal from './AppLayout/LocationModal/LocationModal';
import RoleSelector from './AppLayout/RoleSelector/RoleSelector';
import Stats from './Stats/Stats';
import AdminParts from './AdminParts/AdminParts';
import AdminUsers from './AdminUsers/AdminUsers';
import AdminCars from './AdminCars/AdminCars';
import AdminWarehouses from './AdminWarehouses/AdminWarehouses';
import { InboundCars } from './InboundCars';
import 'semantic-ui-css/semantic.min.css';
import './App.css';

@inject('UserStore', 'VisitedStore', 'WarehousesStore')
@observer
class App extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      localesLoaded: false,
    };
  }

  componentDidMount() {
    const { UserStore, VisitedStore, WarehousesStore } = this.props;
    intl
      .init({
        currentLocale: 'it-IT',
        locales: {
          'it-IT': locales,
        },
      })
      .then(() => {
        this.setState({ localesLoaded: true });
      });
    UserStore.fetchUser();
    UserStore.fetch();
    VisitedStore.fetchVisited();
    WarehousesStore.fetch();
  }

  renderRoleSelector = () => {
    const { UserStore } = this.props;
    if (UserStore.isAdmin) {
      return <RoleSelector />;
    } else {
      return null;
    }
  };

  // @NOTE  render contenuti condizionali in base allo stato auth
  renderApp = () => {
    const { UserStore } = this.props;
    if (!UserStore.authStat) {
      return <Login />;
    } else {
      return (
        <BrowserRouter>
          <div>
            <AppLayout>
              <Route
                exact
                path="/"
                render={() => {
                  return <Board />;
                }}
              />
              <Route
                exact
                path="/requests/"
                render={() => {
                  return <Requests />;
                }}
              />
              <Route
                exact
                path="/requests/new/"
                render={props => {
                  return <NewEditRequest {...props} />;
                }}
              />
              <Route
                exact
                path="/requests/:requestId/view"
                render={props => {
                  return <NewEditRequest {...props} />;
                }}
              />
              <Route
                exact
                path="/sales/"
                render={() => {
                  return <Sales />;
                }}
              />
              <Route
                exact
                path="/sales/:saleId/view"
                render={props => {
                  return <Sale {...props} />;
                }}
              />
              <Route
                exact
                path="/clients/"
                render={() => {
                  return <Clients />;
                }}
              />
              <Route
                exact
                path="/clients/:clientId/view/"
                render={props => {
                  return <Client {...props} />;
                }}
              />
              <Route
                exact
                path="/admin-dashboard"
                render={props => {
                  return <Stats {...props} />;
                }}
              />
              <Route
                exact
                path="/admin-parts"
                render={props => {
                  return <AdminParts {...props} />;
                }}
              />
              <Route
                exact
                path="/admin-users"
                render={props => {
                  return <AdminUsers {...props} />;
                }}
              />
              <Route
                exact
                path="/admin-cars"
                render={props => {
                  return <AdminCars {...props} />;
                }}
              />
              <Route
                exact
                path="/admin-warehouses"
                render={props => {
                  return <AdminWarehouses {...props} />;
                }}
              />
              <Route
                exact
                path="/inbound-cars"
                render={props => {
                  return <InboundCars {...props} />;
                }}
              />
              {/* <Route
                exact
                path="/base/"
                render={props => {
                  return <BaseManipulation {...props} />;
                }}
              /> */}
              <LocationModal />
            </AppLayout>
            {this.renderRoleSelector()}
          </div>
        </BrowserRouter>
      );
    }
  };

  render() {
    const { localesLoaded } = this.state;
    return <div>{localesLoaded && this.renderApp()}</div>;
  }
}

export default App;
